import { useParticipantQuery as e, useParticipantsQuery as t, useSetExemptMutation as n, useUnblockParticipantMutation as r } from "@frontends/data-access-spg-participants";
import { useDataTable as i } from "@frontends/data-table";
import { DsAlert as a, DsBadge as o, DsButton as s, DsCard as c, DsDialog as l, DsLink as u, DsTabBar as d, DsTabBarItem as f, dsToast as p } from "@frontends/ds";
import { formatDateTime as m, personDetail as h, personName as g } from "@frontends/util-spg-format";
import { useTranslation as _ } from "react-i18next";
import { Fragment as v, jsx as y, jsxs as b } from "react/jsx-runtime";
import { useInstanceQuery as x } from "@frontends/data-access-spg-instances";
import { useAllRetentionRulesQuery as S } from "@frontends/data-access-spg-retention-rules";
import { DecisionsTable as C } from "@frontends/feature-spg-decisions";
import { Page as w, PageHeader as T, PropertyList as E, RowList as D, RowListItem as O } from "@frontends/ui-spg-layout";
import { getApiErrorMessage as k } from "@frontends/util-api-errors";
import { useLocation as A, useParams as j, useSearchParams as M } from "react-router";
import { useForm as N } from "@frontends/form";
import { UiKitAlertDialog as P } from "@frontends/ui-kit";
import { useState as F } from "react";
//#region ../model-spg-participants/src/participant.ts
var I = [
	"active",
	"at_risk",
	"eligible",
	"verifying",
	"new",
	"rejected",
	"removed",
	"blocked"
], L = "feature-spg-participants", R = {
	active: "success",
	at_risk: "warning",
	eligible: "info",
	verifying: "info",
	new: "neutral",
	rejected: "danger",
	removed: "neutral",
	blocked: "danger"
}, z = "all";
function B({ instanceId: e, getParticipantHref: n }) {
	let { t: r } = _(L), a = [
		{
			id: "person",
			label: r("columns.person"),
			isRowHeader: !0,
			cell: (e) => {
				let t = e.person;
				return /* @__PURE__ */ b("div", {
					className: "flex min-w-0 flex-col",
					children: [/* @__PURE__ */ y("span", {
						className: "truncate",
						children: t ? g(t) : "—"
					}), /* @__PURE__ */ y("span", {
						className: "truncate text-sm text-textSecondary",
						children: t && h(t)
					})]
				});
			}
		},
		{
			id: "status",
			label: r("columns.status"),
			width: 150,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ b("div", {
				className: "flex flex-col gap-1",
				children: [/* @__PURE__ */ y(o, {
					size: "sm",
					variant: R[e.status],
					children: r(`statuses.${e.status}`)
				}), e.exempt && /* @__PURE__ */ y("span", {
					className: "text-sm text-textSecondary",
					children: r("exempt")
				})]
			})
		},
		{
			id: "email",
			label: r("columns.email"),
			width: 220,
			cell: (e) => e.verifiedEmail || /* @__PURE__ */ y("span", {
				className: "text-textTertiary",
				children: "—"
			})
		},
		{
			id: "status_changed_at",
			label: r("columns.since"),
			isSortable: !0,
			width: 170,
			cell: (e) => m(e.statusChangedAt)
		},
		{
			id: "last_interaction_at",
			label: r("columns.lastSeen"),
			isSortable: !0,
			width: 170,
			cell: (e) => m(e.lastInteractionAt)
		}
	], s = i({
		"aria-label": r("table.label"),
		columns: a,
		defaultSort: {
			by: "status_changed_at",
			order: "desc"
		},
		getRowKey: (e) => e.id,
		getRowHref: (e) => n(e.id),
		pageSize: 25,
		filters: {
			status: {
				type: "select",
				label: r("filters.status"),
				defaultValue: z,
				options: [{
					value: z,
					label: r("filters.allStatuses")
				}, ...I.map((e) => ({
					value: e,
					label: r(`statuses.${e}`)
				}))]
			},
			search: {
				type: "search",
				label: r("filters.search"),
				defaultValue: ""
			}
		}
	}), { status: c, search: l } = s.filters, u = t(s.requestParams, {
		instanceId: e,
		search: l,
		status: c === z ? void 0 : c
	});
	return /* @__PURE__ */ b(s.Frame, { children: [/* @__PURE__ */ y(s.Toolbar, {}), /* @__PURE__ */ y(s.Table, {
		query: u,
		emptyState: {
			icon: "users",
			title: r("empty.title")
		}
	})] });
}
//#endregion
//#region src/lib/components/ParticipantActions.tsx
function V({ participant: e }) {
	let { t } = _(L), [i, a] = F(null), o = () => a(null), c = r(), l = n(), u = (e, n) => {
		p.danger({
			title: e,
			description: k(n, t("actions.failedFallback"))
		});
	}, d = async () => {
		try {
			await c.mutateAsync(e.id), p.success({ title: t("actions.unblock.done") }), o();
		} catch (e) {
			u(t("actions.unblock.failed"), e);
		}
	}, f = async () => {
		try {
			await l.mutateAsync({
				id: e.id,
				exempt: !1,
				reason: ""
			}), p.success({ title: t("actions.lift.done") }), o();
		} catch (e) {
			u(t("actions.lift.failed"), e);
		}
	};
	return /* @__PURE__ */ b("div", {
		className: "flex flex-wrap items-center gap-3",
		children: [
			e.status === "blocked" && /* @__PURE__ */ y(s, {
				variant: "secondary",
				onPress: () => a("unblock"),
				children: t("actions.unblock.open")
			}),
			e.exempt ? /* @__PURE__ */ y(s, {
				variant: "secondary",
				onPress: () => a("lift"),
				children: t("actions.lift.open")
			}) : /* @__PURE__ */ y(s, {
				variant: "secondary",
				onPress: () => a("exempt"),
				children: t("actions.exempt.open")
			}),
			i === "unblock" && /* @__PURE__ */ y(P, {
				open: !0,
				onOpenChange: (e) => !e && o(),
				title: t("actions.unblock.title"),
				description: t("actions.unblock.description"),
				confirmLabel: t("actions.unblock.confirm"),
				cancelLabel: t("actions.cancel"),
				onConfirm: () => void d()
			}),
			i === "lift" && /* @__PURE__ */ y(P, {
				open: !0,
				onOpenChange: (e) => !e && o(),
				title: t("actions.lift.title"),
				description: t("actions.lift.description", { reason: e.exemptReason }),
				confirmLabel: t("actions.lift.confirm"),
				cancelLabel: t("actions.cancel"),
				onConfirm: () => void f()
			}),
			i === "exempt" && /* @__PURE__ */ y(H, {
				participantId: e.id,
				onClose: o
			})
		]
	});
}
function H({ participantId: e, onClose: t }) {
	let { t: r } = _(L), i = n(), a = N({
		fields: { reason: {
			type: "text",
			label: r("actions.exempt.reason"),
			description: r("actions.exempt.hint"),
			validators: ["required", { maxLength: 128 }]
		} },
		submitLabel: r("actions.exempt.confirm"),
		fieldMap: { exempt_reason: "reason" },
		onSubmit: async (n) => {
			await i.mutateAsync({
				id: e,
				exempt: !0,
				reason: String(n.reason).trim()
			}), p.success({ title: r("actions.exempt.done") }), t();
		}
	});
	return /* @__PURE__ */ y(l, {
		title: r("actions.exempt.title"),
		isOpen: !0,
		onOpenChange: (e) => !e && t(),
		children: /* @__PURE__ */ y(a.Form, { className: "flex flex-col gap-4" })
	});
}
//#endregion
//#region src/lib/pages/ParticipantPage.tsx
var U = "overview", W = "history";
function G({ title: e, rows: t }) {
	return /* @__PURE__ */ y(c, {
		title: e,
		children: /* @__PURE__ */ y(E, { items: t.map(([e, t]) => ({
			label: e,
			value: t
		})) })
	});
}
function K({ getInstanceParticipantsHref: t, getRuleHref: n, instancesHref: r }) {
	let { t: i } = _(L), { instanceId: s = "", participantId: c = "" } = j(), l = e(c), u = x(s).data, [p] = M(), { pathname: m } = A(), h = p.get("tab") ?? U, S = (e) => e === U ? m : `${m}?tab=${e}`, E = l.data?.person;
	return /* @__PURE__ */ b(w, { children: [
		/* @__PURE__ */ y(T, {
			trail: [{
				href: r,
				label: i("view.instances")
			}, {
				href: t(s),
				label: u?.name ?? "…"
			}],
			title: E ? g(E) : "…",
			status: l.data && /* @__PURE__ */ y(o, {
				variant: R[l.data.status],
				children: i(`statuses.${l.data.status}`)
			}),
			actions: l.data && /* @__PURE__ */ y(V, { participant: l.data })
		}),
		l.isPending && /* @__PURE__ */ y("p", {
			className: "text-base text-textSecondary",
			children: i("view.loading")
		}),
		l.isError && /* @__PURE__ */ y(a, {
			variant: "danger",
			title: i("view.loadFailed"),
			description: k(l.error, i("view.loadFailedDetail")),
			actionLabel: i("view.retry"),
			onAction: () => void l.refetch()
		}),
		l.data && /* @__PURE__ */ b(v, { children: [
			/* @__PURE__ */ y(d, {
				"aria-label": i("tabs.label"),
				selectedKey: h,
				keyboardActivation: "manual",
				children: [U, W].map((e) => /* @__PURE__ */ y(f, {
					id: e,
					href: S(e),
					children: i(`tabs.${e}`)
				}, e))
			}),
			h === U && /* @__PURE__ */ y(q, {
				participant: l.data,
				getRuleHref: n
			}),
			h === W && /* @__PURE__ */ y(C, {
				scope: {
					instanceId: l.data.instanceId,
					participationId: l.data.id
				},
				getRuleHref: n
			})
		] })
	] });
}
function q({ participant: e, getRuleHref: t }) {
	let { t: n } = _(L), r = x(e.instanceId).data, i = S().data ?? [], a = new Map(r?.channels.map((e) => [e.id, e.title])), s = i.find((t) => t.id === e.atRiskRuleId), l = [
		[n("fields.statusSince"), m(e.statusChangedAt)],
		...e.status === "verifying" || e.status === "new" ? [[n("fields.currentStep"), n(`steps.${e.currentStepKey}`, { defaultValue: e.currentStepKey })]] : [],
		...e.atRiskRuleId ? [[n("fields.atRiskBy"), /* @__PURE__ */ y(u, {
			href: t(e.atRiskRuleId),
			children: s?.name ?? n("unknown")
		}, "rule")], [n("fields.graceUntil"), m(e.graceDeadlineAt)]] : [],
		...e.suspendedUntil ? [[n("fields.suspendedUntil"), m(e.suspendedUntil)]] : [],
		[n("fields.exempt"), e.exempt ? e.exemptReason || n("exempt") : n("no")],
		[n("fields.firstGranted"), m(e.firstGrantedAt)],
		[n("fields.lastGranted"), m(e.lastGrantedAt)],
		[n("fields.lastRemoved"), m(e.lastRemovedAt)],
		[n("fields.lastSeen"), m(e.lastInteractionAt)],
		[n("fields.joinedTheBot"), m(e.createdAt)]
	], d = [
		[n(`platforms.${e.person.platform}`), /* @__PURE__ */ y("span", {
			className: "font-mono",
			children: h(e.person)
		}, "person")],
		[n("fields.language"), e.language || "—"],
		[n("fields.email"), e.verifiedEmail || "—"],
		[n("fields.brands"), e.linkedBrands.map((e) => e.toUpperCase()).join(", ") || "—"],
		[n("fields.accounts"), e.tradingAccounts.length > 0 ? e.tradingAccounts.map((e) => `${e.brand.toUpperCase()} ${e.server.toUpperCase()} #${e.login}`).join(", ") : "—"]
	];
	return /* @__PURE__ */ b("div", {
		className: "grid items-start gap-6 lg:grid-cols-2",
		children: [/* @__PURE__ */ y("div", {
			className: "flex min-w-0 flex-col gap-6",
			children: /* @__PURE__ */ y(G, {
				title: n("view.standing"),
				rows: l
			})
		}), /* @__PURE__ */ b("div", {
			className: "flex min-w-0 flex-col gap-6",
			children: [/* @__PURE__ */ y(G, {
				title: n("view.account"),
				rows: d
			}), /* @__PURE__ */ y(c, {
				title: n("view.channels"),
				children: e.presences.length === 0 ? /* @__PURE__ */ y("p", {
					className: "text-base text-textSecondary",
					children: n("view.noChannels")
				}) : /* @__PURE__ */ y(D, { children: e.presences.map((e) => /* @__PURE__ */ b(O, {
					action: /* @__PURE__ */ y(o, {
						size: "sm",
						children: n(`presence.${e.state}`)
					}),
					children: [/* @__PURE__ */ y("span", {
						className: "truncate text-textPrimary",
						children: a.get(e.channelId) ?? n("unknown")
					}), /* @__PURE__ */ b("span", {
						className: "text-sm text-textSecondary",
						children: [n("presence.since", { time: m(e.stateChangedAt) }), e.removedReason && ` · ${e.removedReason}`]
					})]
				}, e.channelId)) })
			})]
		})]
	});
}
//#endregion
export { L as FEATURE_SPG_PARTICIPANTS_NAMESPACE, K as ParticipantPage, B as ParticipantsTable };
